const toNumber = (value, fallback = 0) => {
    const n = Number(value);
    return Number.isFinite(n) ? n : fallback;
};

export const sameBatchPeriod = (a, b) => {
    if (!a || !b) return false;
    return toNumber(a.year) === toNumber(b.year)
        && toNumber(a.monthFrom, 1) === toNumber(b.monthFrom, 1)
        && toNumber(a.monthTo, 12) === toNumber(b.monthTo, 12);
};

/**
 * Okres biegu wybranego na ekranie raportów. Od okresu zależy, pod jakim miesiącem zapisują
 * się odhaczenia i komentarze, więc nieznany okres zwraca null zamiast okresu bieżącego.
 */
export const periodOfRun = (runId, runs, currentPeriod) => {
    if (runId === '__current__') return currentPeriod || null;
    const period = (runs || []).find(run => run.runId === runId)?.period;
    if (!period || !toNumber(period.year) || !toNumber(period.monthTo)) return null;
    return { year: toNumber(period.year), monthFrom: toNumber(period.monthFrom) || 1, monthTo: toNumber(period.monthTo) };
};

export const batchRunPrefixForPeriod = (period) => {
    if (!period) return '';
    return `batch-${toNumber(period.year)}-${toNumber(period.monthFrom, 1)}-${toNumber(period.monthTo, 12)}`;
};

const runIdMatchesPeriod = (runId, period) => {
    const prefix = batchRunPrefixForPeriod(period);
    if (!prefix || !runId) return false;
    return runId === prefix || String(runId).startsWith(`${prefix}-`);
};

const isAuditorRun = (run) => String(run?.runId || '').includes('-auditor');

const roleRank = (run, userRole) => {
    if (userRole === 'auditor') return isAuditorRun(run) ? 0 : 1;
    if (userRole === 'admin') return isAuditorRun(run) ? 1 : 0;
    return 0;
};

export const runMatchesBatchPeriod = (run, period) => (
    sameBatchPeriod(run?.period, period) || runIdMatchesPeriod(run?.runId, period)
);

export const selectBatchRunForPeriod = (runs, period, userRole = 'admin') => {
    return [...(runs || [])]
        .filter(run => runMatchesBatchPeriod(run, period))
        .sort((a, b) => {
            const roleDiff = roleRank(a, userRole) - roleRank(b, userRole);
            if (roleDiff !== 0) return roleDiff;
            return toNumber(b.savedAt) - toNumber(a.savedAt);
        })[0] || null;
};

export const selectLatestBatchRun = (runs, userRole = 'admin') => {
    return [...(runs || [])]
        .sort((a, b) => {
            const roleDiff = roleRank(a, userRole) - roleRank(b, userRole);
            if (roleDiff !== 0) return roleDiff;
            return toNumber(b.savedAt) - toNumber(a.savedAt);
        })[0] || null;
};
